import React from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import AdminAccountsPage from "../pages/AdminAccountsPage";
import AdminAccountDetailPage from "../pages/AdminAccountDetailPage";
import AdminBulkAccountCreationPage from "../pages/AdminBulkAccountCreationPage";
import AdminSubscriptionsPage from "../pages/AdminSubscriptionsPage";
import AdminPartnerPage from "../pages/AdminPartnerPage";
import AdminCronJobsPage from "../pages/AdminCronJobsPage";
import AdminPatchingCenterPage from "../pages/AdminPatchingCenterPage";
import AdminSecurityPage from "../pages/AdminSecurityPage";
import AdminNotFoundPage from "../pages/AdminNotFoundPage";
import AdminForbiddenPage from "../pages/AdminForbiddenPage";
import AuditLogPage from "../pages/AuditLogsPage";

const AdminRedirect = ({ to }) => {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
};

const LegacyAccountRedirect = () => {
  const { u_id } = useParams();
  return <AdminRedirect to={`/internal/accounts/list/${encodeURIComponent(u_id)}`} />;
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path='' element={<AdminRedirect to='/internal/accounts/list' />} />
      <Route path='accounts' element={<AdminRedirect to='/internal/accounts/list' />} />
      <Route path='accounts/list' element={<AdminAccountsPage />} />
      <Route path='accounts/list/:u_id' element={<AdminAccountDetailPage />} />
      <Route path='accounts/promo-codes' element={<AdminPartnerPage />} />
      <Route path='accounts/bulk-creation' element={<AdminBulkAccountCreationPage />} />
      <Route path='accounts/:u_id' element={<LegacyAccountRedirect />} />
      <Route path='subscriptions' element={<AdminSubscriptionsPage />} />
      <Route path='partner' element={<AdminRedirect to='/internal/accounts/promo-codes' />} />
      <Route path='cronjob' element={<AdminCronJobsPage />} />
      <Route path='security' element={<AdminSecurityPage />} />
      <Route path='patching-center' element={<AdminPatchingCenterPage />} />
      <Route path='audit-logs' element={<AuditLogPage />} />
      <Route path='forbidden' element={<AdminForbiddenPage />} />
      <Route path='*' element={<AdminNotFoundPage />} />
    </Routes>
  );
};

export default AdminRoutes;
